const basicHtmlToText = (html: string) => {
  if (!html) return "";

  return html
    .replace(/<!--[\s\S]*?-->/g, "") // remove HTML comments
    .replace(/<br\s*\/?>/gi, "\n") // convert <br> to line break
    .replace(/<\/p>/gi, "\n") // convert </p> to line break
    .replace(/<\/div>/gi, "\n") // convert </div> to line break
    .replace(/<[^>]+>/g, "") // strip all remaining tags
    .replace(/\n\s*\n+/g, "\n\n") // collapse multiple line breaks
    .trim();
};

export const onGmailShare = (policyData: any) => {
  const to = policyData?.Draft?.to || "";
  const subject = encodeURIComponent(policyData?.Draft?.subject || "");
  const body = encodeURIComponent(basicHtmlToText(policyData?.Draft?.bodyHtml));
  const bcc = policyData?.Draft?.bcc || "";

  const mailtoUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}&bcc=${bcc}`;
  window.open(mailtoUrl, "_blank");
};

export const areAllObjectsKeysNull = (obj: any) => {
  if (!obj) return true;
  return Object.values(obj).every((value: any) => value === null);
};

export const regextForDiv = /^\s*<div[^>]*>[\s\S]*<\/div>\s*$/;

export const ALL_POLICY_TYPES = Object.freeze({
  HEALTH: "3030b68f-82e9-4dfb-b2b8-82b743d0692a",
  LIFE: "864a375b-5fa7-49c7-9f39-2b1fda4674b5",
  MOTOR: "7e5ecc07-70e3-40a3-95a0-f0bee04814d4"
});
